module.exports = __webpack_public_path__ + "fonts/effect-stun-6ec635.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-stun.svg
// module id = 836
// module chunks = 0